import {Injectable, OnDestroy} from '@angular/core';
import {NavigationStart, Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PrlPreviousRouteService implements OnDestroy{

    private static ERROR_PAGES: Array<string> = ['/404', '/403', '/500', '/503', '/504'];

    private previousUrl: string;
    private currentUrl: string;

    private _destroy$$: Subject<null> = new Subject<null>();

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        this.router.events.pipe(takeUntil(this._destroy$$)).subscribe(event => {
            if (event instanceof NavigationStart && this.currentUrl !== event.url) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            }
        });
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }

    public getPreviousUrl(): string {
        if (!this.previousUrl
            || this.previousUrl.includes('reset-password')
            || PrlPreviousRouteService.ERROR_PAGES.indexOf(this.previousUrl) > -1) {
            return '/dashboard';
        }
        return this.previousUrl;
    }

    public navigatePreviousPage(): void {
        this.router.navigateByUrl(this.getPreviousUrl());
    }
}
